<template>
  <hr />
  <h4>
    Anexos:
    <span
      role="button"
      class="badge bg-primary"
      title="Cadastrar Anexo"
      @click="$emit('createAttachment')"
    >
      Cadastrar
    </span>
  </h4>
  <ul v-if="attachments.length > 0" class="list list-unstyled">
    <li v-for="attachment in attachments" :key="attachment.id">
      <a :href="attachment.link" :title="attachment.link" target="_blank">
        <i
          class="fas mr-1"
          :class="{
            'ph-paperclip': attachment.type == 1,
            'ph-arrow-square-out': attachment.type == 2,
          }"
        />
        {{ attachment.name }}
      </a>
      <span
        role="button"
        class="badge bg-danger ms-2"
        title="Excluir Anexo"
        @click="$emit('deleteAttachment', attachment.id)"
      >
        Excluir
      </span>
    </li>
  </ul>
  <p v-else>Nenhum anexo cadastrado</p>
</template>

<script>
export default {
  name: 'AttachmentsLesson',

  props: {
    attachments: {
      type: Array,
      required: true,
    },
  },

  emits: ['createAttachment', 'deleteAttachment'],
}
</script>
